<template>
  <b-container class="search-area" fluid="lg">

    <b-form-row class="mb-4">
      <b-col class="form-group">
        <h3 class="common__search-title">Subject name</h3>
        <input type="text" class="form-control" v-model="subject" />
      </b-col>

      <b-col class="form-group">
        <h3 class="common__search-title">Status</h3>
        <div>
          <label v-for="(status, code) of mailStatuses" class="checkbox" :key="code">
            <input type="checkbox" v-model="statuses" :value="code" />{{ status }}
          </label>
        </div>
      </b-col>

      <b-col class="form-group">
        <h3 class="common__search-title">University</h3>
          <div>
            <SelectUniversityInput
              v-model="university"
              class="form-control w-50"
            />
          </div>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="8">
        <h3 class="common__search-title">Mail send date</h3>
        <b-row class="ml-2">
          <b-col>
            <div class="form-group">
              <label class="form-label">From</label>
              <DateInput v-model="from" />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-label">To</label>
              <DateInput v-model="to" />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="8">
        <h3 class="common__search-title">Target</h3>
        <b-row>
          <b-col>
            <div class="form-group">
              <b-form-radio-group v-model="targetType">
                <b-form-radio v-for="(target, code) of mailTargets" :key="code" :value="code">
                  {{ target }}
                </b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="targetType !== null">
          <b-col>
            <div class="form-group">
              <input type="text" class="form-control"
                v-model="targetWord"
                :placeholder="targetType === 'tutor' ? 'Tutor ID' : 'Student Number'"
              />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-form-row>

    <div class="d-flex justify-content-end">
      <b-button pill variant="secondary" @click="reset" class="mr-2">
        Reset
      </b-button>
      <b-button pill variant="primary" @click="search">
        Search
      </b-button>
    </div>

  </b-container>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import DateInput from '@/components/parts/inputItem/DateInput.vue'
import SelectUniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import {
  MailsConditions,
  mailSendStatueType,
  MailSendStatuses,
  MailTargets,
  mailTargetType,
} from '@/store/mails/types'
import { University } from '@/store/master/types'
import { Moment } from 'moment'

@Component({
  components: {
    DateInput,
    SelectUniversityInput,
  },
})
export default class MailsSearchConditions extends Vue {
  private subject: string = ''

  private statuses: mailSendStatueType[] = []

  private university: University|null = null

  private from: Moment|null = null

  private to: Moment|null = null

  private targetType: mailTargetType = 'tutor'

  private targetWord: string = ''

  private mailStatuses = MailSendStatuses

  private mailTargets = MailTargets

  private search(): void {
    const conditions: MailsConditions = {
      subject: this.subject,
      statuses: this.statuses,
      university: this.university,
      from: this.from,
      to: this.to,
      target: (this.targetType) ? {
        type: this.targetType,
        word: this.targetWord,
      } : null,
    }
    this.$emit('changedConditions', conditions)
  }

  private reset(): void {
    this.subject = ''
    this.statuses = []
    this.university = null
    this.from = null
    this.to = null
    this.targetType = 'tutor'
    this.targetWord = ''

    this.search()
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
  vertical-align: middle;
}

.checkbox {
  margin-right:20px;
}
</style>
